<template>
  <v-app>
    <v-main class="risq-gradient">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card>
              <v-card-title primary-title>
                {{ appName }}
              </v-card-title>
              <v-card-subtitle>
              Dev environment login
              </v-card-subtitle>
              <v-divider></v-divider>
              <v-card-text>
               Choose a mock user for the dev environment   
                <v-list>
                  <v-list-item-group v-model="chosenUser" color="primary">
                    <v-list-item v-for="(item, i) in mockUsers" :key="i" style="border-top: 1px solid #ccc" >
                      <v-list-item-icon>
                        <v-avatar color="primary">
                          <v-icon dark>mdi-account-outline</v-icon>
                        </v-avatar>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title
                          class="font-weight-medium"
                          v-text="item.name"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                        class="grey--text mb-2">
                          {{ item.desc }}
                        </v-list-item-subtitle>
                        <div v-text="item.account.name"></div>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-card-text>
              <!--
        <% unless notice.blank? %>
          <v-alert outlined type="info" elevation="1" align="center">
            <%= notice %>
          </v-alert>
        <% end %>
        <% unless alert.blank? %>
          <v-alert dense outlined type="warning" elevation="1" align="center">
            <%= alert %>
          </v-alert>
        <% end %>
            -->
            </v-card>
          </v-col>
        </v-row>
      </v-container>
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>
<style media="screen">
.risq-gradient {
  background: linear-gradient(
    321deg,
    rgba(0, 158, 216, 0.7) 0%,
    rgba(83, 201, 0, 0.7) 100%
  );
}
</style>
<script>
import { mapState } from "vuex";
export default {
  name: "MockLogin",
  mounted() {
    console.log(this.$root);
  },
  computed: {
    ...mapState(["appName"]),
  },
  watch: {
      chosenUser: function(userIndex) {
        const mUser = this.mockUsers[userIndex]
        this.$store.dispatch('setUserFromObject',mUser).then(() => {
            this.$cookies.set('t',mUser)
            this.$router.push({name: 'Home'})
        })
      }
  },
  methods: {
      mockLogin(userIndex) {
          
      }
  },
  data: () => ({
    chosenUser: null,
    mockUsers: [
        {
            "desc": "ICE DII Team User",
            "user_id": 2,
            "name": "Addison Zambrano",
            "email": "addison.zambrano@ice.com",
            "account": {
                "id": 1,
                "name": "RisQ"
            },
            "content_subtypes": "pt,crt,cmbs,na,tba",
            "trial": false
        },
      {
            "desc": "ICE DII Team User",
            "user_id": 6,
            "name": "Clarence Brunetti",
            "email": "clarence.brunetti@ice.com",
            "account": {
                "id": 1,
                "name": "RisQ"
            },
            "content_subtypes": "pt,crt,cmbs,na,tba",
            "trial": false
        },        
        {
            "desc": "Fake Client with CRT and CMBS access",
            "user_id": 29,
            "name": "Farren Huerta",
            "email": "farren.huerta@tigermountain.com",
            "account": {
                "id": 7,
                "name": "Tiger Mountain Strategies"
            },
            "content_subtypes": "crt,cmbs",
            "trial": false
        }
    ],
  }),
};
</script>